export default __webpack_public_path__ + "static/media/sy.9d13beb5.svg";